<template>
  <v-card class="exercise-action__move-menu"> 
    <v-card-title>
      Move definition to folder
      <v-spacer/>
      <v-btn small icon @click.stop="$emit('close')" class="exercise-action__move-menu_close">
        <v-icon size="12">bhi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-list link dense>
        <v-list-item-group mandatory v-model="selected">
          <v-list-item :key="0" @click.stop="selectMainFolder">
            <v-list-item-icon>
              <v-icon color="accent">bhi-folder-filled</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Main</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item  v-for="(folder, i) in folders" :key="i+1" @click.stop="selectFolder(folder)">
            <v-list-item-icon>
              <v-icon>bhi-folder-filled</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{folder.title}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card-text>
    <v-card-actions>
      <!-- <v-btn icon small>
        <v-icon color="accent">bhi-folder-add-filled</v-icon>
      </v-btn> -->
      <span></span>
      <v-btn small text color="accent" @click="move">
        Move
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'ExerciseActionMenu',
  props: {
    id: {
      type: Number,
      default: 0
    },
    version: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      selected: 0,
      selectedFolder: null
    }
  },
  computed: {
    ...mapState('exercisesStates', [
      'exerciseFolders'
    ]),
    folders() {
      return this.exerciseFolders
    }
  },
  methods: {
    selectFolder(folder) {
      this.selectedFolder = folder.id
    },
    selectMainFolder() {
      this.selectedFolder = null
    },
    move() {
      this.$emit('move-exercise', this.selectedFolder)
    }
  }
}
</script>

<style lang="scss">
.exercise-action {

  &__move-menu {
    .v-item-group {
      max-height: 150px;
      overflow: auto;
    }
    .v-card__title {
      background: $bh-blue;
      min-width: 335px;
      color: $bh-white;
      padding: 0 6px 0 6px;
      font-size: 1rem;
      line-height: 40px;
      display: flex;
      .ml {
        margin-left: 10px;
      }
      .v-icon {
        color: $bh-white;
      }
    }
    &_close {
      margin-left: auto;
    }
    .v-card__text {
      padding: 0px;
      .v-list {
        background: $bh-blue--4;
        .v-list-item {
          min-height: 30px;
          &__icon {
            align-self: center;
            &:first-child {
              margin: 0 3px 0 0;
              .v-icon {
                color: $bh-gray--2;
              }
            }
          }
          &__content {
            padding:0 !important;
            color: $bh-gray--2;
          }
        }
      }
    }
    .v-card__actions {
      background: $bh-blue--4;
      position: relative;
      justify-content: space-between;
      .v-btn {
        z-index: 1;
      }
      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: $bh-white;
        opacity: 0.5;
        z-index: 0;
      }
    }
  }
}
</style>